import { client } from "../../../api/client";

export const createNewQuoteFolderStructure = async (sharepoint, isMain, quoteId, revisionNumber, quoteFileName) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.get('https://localhost:5701/', `sharepointapi/opportunity/createNewFolderStructure?sharepoint=${sharepoint}&isMain=${isMain}&quoteId=${quoteId}&revisionNumber=${revisionNumber}&quoteFileName=${quoteFileName}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error creating quote folder structure:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/createNewFolderStructure?sharepoint=${sharepoint}&isMain=${isMain}&quoteId=${quoteId}&revisionNumber=${revisionNumber}&quoteFileName=${quoteFileName}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error creating quote folder structure:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const createNewRevisionFolderStructure = async (sharepoint, quoteId, revisionNumber, isActive, isMain, oldRevisionNumber) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.get('https://localhost:5701/', `sharepointapi/opportunity/createNewRevisionFolderStructure?sharepoint=${sharepoint}&quoteId=${quoteId}&revisionNumber=${revisionNumber}&isActive=${isActive}&isMain=${isMain}&oldRevisionNumber=${oldRevisionNumber}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error creating revision folder structure:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/createNewRevisionFolderStructure?sharepoint=${sharepoint}&quoteId=${quoteId}&revisionNumber=${revisionNumber}&isActive=${isActive}&isMain=${isMain}&oldRevisionNumber=${oldRevisionNumber}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error creating revision folder structure:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const duplicateQuoteFolderStructure = async (oldSharepoint, sharepoint, oldRevisionNumber, oldQuoteId, quoteId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.get('https://localhost:5701/', `sharepointapi/opportunity/duplicateQuoteFolderStructure?oldSharepoint=${oldSharepoint}&sharepoint=${sharepoint}&quoteId=${quoteId}&oldRevisionNumber=${oldRevisionNumber}&oldQuoteId=${oldQuoteId}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error duplicating quote folder structure:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/duplicateQuoteFolderStructure?oldSharepoint=${oldSharepoint}&sharepoint=${sharepoint}&quoteId=${quoteId}&oldRevisionNumber=${oldRevisionNumber}&oldQuoteId=${oldQuoteId}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error duplicating quote folder structure:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const finaliseQuote = async (formdata) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.post('https://localhost:5701/', `sharepointapi/opportunity/finaliseQuote`, formdata);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error finalising quote:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/finaliseQuote`, formdata);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error finalising quote:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const importQuoteFile = async (formdata) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.post('https://localhost:5701/', `sharepointapi/opportunity/importFile`, formdata);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error importing quote file:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/importFile`, formdata);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error importing quote file:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const exportQuoteFile = async (formdata) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.post('https://localhost:5701/', `sharepointapi/opportunity/exportFile`, formdata);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error exporting quote file:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/exportFile`, formdata);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error exporting quote file:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const replaceActiveQuoteInLiveFolder = async (sharepoint, quoteId, revisionNumber) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.put('https://localhost:5701/', `sharepointapi/opportunity/replaceActiveQuoteInLiveFolder?sharepoint=${sharepoint}&quoteId=${quoteId}&revisionNumber=${revisionNumber}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error replacing active quote in live folder:", error);
            return { message: error.message, responseOk: false };
        }
    } else {
        try {
            const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/replaceActiveQuoteInLiveFolder?sharepoint=${sharepoint}&quoteId=${quoteId}&revisionNumber=${revisionNumber}`);
            return { message: response.data, responseOk: response.ok };
        } catch (error) {
            console.error("Error replacing active quote in live folder:", error);
            return { message: error.message, responseOk: false };
        }
    }
}

export const validateAndNormaliseUrl = async (sharepointUrl, quoteId) => {
    const baseUrl = process.env.REACT_APP_USELOCALDATA === "true"
        ? "https://localhost:5701/"
        : process.env.REACT_APP_GATEWAY_URI;

    try {
        const params = new URLSearchParams({
            sharepointUrl: String(sharepointUrl),
            quoteId: String(quoteId)
        });
        const response = await client.get(
            baseUrl,
            `sharepointapi/opportunity/validateAndNormaliseUrl?${params.toString()}`
        );
        return response.data;
    } catch (error) {
        console.error("Error validating and normalising URL:", error);
        return { isValid: false, reason: error?.message || "Error validating and normalising URL" };
    }
}

export const verifyFolderExists = async (sharepointUrl, relativePath, quoteId) => {
    const baseUri = process.env.REACT_APP_USELOCALDATA === "true"
        ? 'https://localhost:5701/'
        : process.env.REACT_APP_GATEWAY_URI;

    try {
        const qs = new URLSearchParams({
            sharepointUrl: String(sharepointUrl),
            relativePath: String(relativePath),
            quoteId: String(quoteId)
        }).toString();
        const response = await client.get(baseUri, `sharepointapi/opportunity/verifyFolderExists?${qs}`);
        return { message: response.data, responseOk: response.ok };
    } catch (error) {
        console.error("Error verifying if folder exists:", error);
        return { message: error.message, responseOk: false };
    }
}

export const getOpportunityLiveFiles = async (sharepointUri, quoteId, revisionNumber, quoteTemplateFileName, isRegeneration, exportTemplateFileNames, includeFilesToBeInserted) => {
    const baseUri = process.env.REACT_APP_USELOCALDATA === "true"
        ? 'https://localhost:5701/'
        : process.env.REACT_APP_GATEWAY_URI;
    try {
        const params = new URLSearchParams({
            quoteId: String(quoteId),
            revisionNumber: String(revisionNumber),
            quoteTemplateFileName: String(quoteTemplateFileName),
            isRegeneration: isRegeneration === true ? "true" : "false",
            includeFilesToBeInserted: includeFilesToBeInserted === true ? "true" : "false"
        });

        // omit the param entirely when there are no file names, so the backend receives an empty array instead of [null]
        (exportTemplateFileNames ?? []).forEach(fileName => params.append('exportTemplateFileNames', fileName));
        const response = await client.post(baseUri, `sharepointapi/opportunity/getOpportunityLiveFiles?${params.toString()}`, sharepointUri);
        return { message: response.data, responseOk: response.ok };
    } catch (error) {
        console.error("Error getting opportunity live files:", error);
        return { message: error.message, responseOk: false };
    }
}

export const hasGeneratedQuote = async (sharepointUri, quoteId, revisionNumber) => {
    const baseUri = process.env.REACT_APP_USELOCALDATA === "true"
        ? 'https://localhost:5701/'
        : process.env.REACT_APP_GATEWAY_URI;

    try {
        const response = await client.post(baseUri, `sharepointapi/opportunity/hasGeneratedQuote?quoteId=${quoteId}&revisionNumber=${revisionNumber}`, sharepointUri);
        return { message: response.data, responseOk: response.ok };
    } catch (error) {
        console.error("Error checking if quote has been generated:", error);
        return { message: error.message, responseOk: false };
    }
}